import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import CustomerDeleteModalUI from './CustomerDeleteModalUI.js'

class CustomerDeleteModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      successMsg: null,
      errorList: null,
      submitted: false,
      customerName: '',
    }
  }

  render() {
    return (
      <CustomerDeleteModalUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        customerList={this.props.customerList}
        // delete mode
        deleteMode={this.props.deleteMode}
        // customerName
        customerName={this.state.customerName}
        // form events
        onConfirmDeleteClick={this.onSubmit}
        submitted={this.state.submitted}
        setErrorList={this.setErrorList}
        onCancelClick={this.onCancelClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
  }

  componentDidUpdate(prevProps) {
    let customer = this.props.customer
    if (!customer)
      return
    if (prevProps.customer && prevProps.customer.customerId == customer.customerId)
      return

    this.setState({
      customerName: customer.customerName,
    })
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    let id = this.props.customer.customerId

    RestApiUtils.delete(this.props.context,
      `/api/accounts/${this.props.context.session.accountId}/customers/${id}`,
      this.onSubmitCallback);
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    if (response.errorList.length !== 0) {
      this.setState({
        errorList: errorList,
        submitted: false,
      })

      return;
    }

    this.setState({
      successMsg: response.success,
      submitted: false,
    })

    setTimeout(() => {
      this.setState({ successMsg: null })
    }, 2000)

    this.props.onDeleteComplete(response.customer)
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
    if (errorList && errorList.length > 0)
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }

  onCancelClick = () => {
    this.setState({
      successMsg: null,
      errorList: null,
      submitted: false
    })

    this.props.onCancelClick()
  }

  getMessages(context) {
    let arr = [
      'c_delete_customer',
      'c_remove',
      'c_cancel',
      'c_customer_name',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('cust_del4', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({ messageList: response.messageList })
  }
}

export default withRouter(CustomerDeleteModalSF)
